/**
 * @desc: 路由映射
 * @created: 2020/6/1
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'

// 获取列表数据
export const getListData = params => {
  return request.get('/routemapping/list', params)
}

// 获取供应商详情
export const getSupplierDetails = params => {
  return request.get('/routemapping/detail', params)
}

// 批量映射
export const postBatchRegister = data => {
  return request.post('/routemapping/bank/register', data, { json: true })
}




